const path_login = '/login';
const path_registration = '/registration';
const path_reset_password = '/reset-password';
const path_tier3 = '/tier3';
const path_me_manager = '/me-manager';
const path_production_planning = '/production-planning';
const path_reports = '/reports';
const path_users = '/users';
const path_create_user = '/create-user';
const path_edit_user = '/edit-user/:user_id';
const path_roles = '/roles';
const path_create_role = '/create-role';
const path_edit_role = '/edit-role/:role_id'; 

export {
    path_login,
    path_registration,
    path_reset_password,
    path_tier3,
    path_me_manager,
    path_production_planning,
    path_reports,
    path_users,
    path_create_user,
    path_edit_user,
    path_roles,
    path_create_role,
    path_edit_role
}
